import type {PropsWithChildren} from 'react';
import styles from './top.module.css';

type Props = PropsWithChildren;

export function ImageListTop({children}: Props) {
  return <div className={styles.top}>{children}</div>;
}
